import { render, staticRenderFns } from "./ArchiveAppSelect.vue?vue&type=template&id=c8b0800c&scoped=true"
import script from "./ArchiveAppSelect.vue?vue&type=script&lang=js"
export * from "./ArchiveAppSelect.vue?vue&type=script&lang=js"
import style0 from "./ArchiveAppSelect.vue?vue&type=style&index=0&id=c8b0800c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b0800c",
  null
  
)

export default component.exports